import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { request } from '@app/services';
import { RootState } from '@app/redux/root-reducer';
import * as endpoints from './endpoints';
import {
  getTestimonial,
  getTestimonialFailed,
  getTestimonialSuccess,
  deleteTestimonial,
  deleteTestimonialSuccess,
  deleteTestimonialFailed,
  addTestimonial,
  addTestimonialSuccess,
  addTestimonialFailed,
  updateTestimonial,
  updateTestimonialSuccess,
  updateTestimonialFailed,
} from './slice';

//
function* getTestimonialSaga(action: ReturnType<typeof getTestimonial>): any {
  try {
    const result = yield call(request.get, endpoints.getTestimonial);
    yield put(getTestimonialSuccess(result.data));
  } catch (err) {
    yield put(getTestimonialFailed(err));
  }
}
//
function* deleteTestimonialSaga(action: ReturnType<typeof deleteTestimonial>): any {
  try {
    const { id } = action.payload;
    const { data } = yield select((store: RootState) => store.testimonialReducer.testimonial);
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.delete, `${endpoints.deleteTestimonial}${id}`);
    yield put(deleteTestimonialSuccess(result.data));
    const updatedTestimonials = data?.filter(
      (testimonial: { id: number }) => testimonial.id !== id
    );
    yield put(getTestimonialSuccess(updatedTestimonials));
  } catch (err) {
    yield put(deleteTestimonialFailed(err));
  }
}

//
function* addTestimonialSaga(action: ReturnType<typeof addTestimonial>): any {
  try {
    const { clientId, feedback, projectLink, projectName } = action.payload;
    const result = yield call(request.post, endpoints.addTestimonial, {
      clientId: Number(clientId),
      feedback,
      projectLink,
      projectName,
    });
    yield put(addTestimonialSuccess(result.data));
  } catch (err) {
    yield put(addTestimonialFailed(err));
  }
}
//
function* updateTestimonialSaga(action: ReturnType<typeof updateTestimonial>): any {
  try {
    const { id, clientId, feedback, projectLink, projectName } = action.payload;
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.put, `${endpoints.updateTestimonial}${id}`, {
      clientId,
      feedback,
      projectLink,
      projectName,
    });
    yield put(updateTestimonialSuccess(result.data.data));
  } catch (err) {
    yield put(updateTestimonialFailed(err));
  }
}
//

function* testimonialSagas() {
  yield all([
    takeLatest(
      [getTestimonial, addTestimonialSuccess, updateTestimonialSuccess],
      getTestimonialSaga
    ),
    takeLatest(deleteTestimonial, deleteTestimonialSaga),
    takeLatest(addTestimonial, addTestimonialSaga),
    takeLatest(updateTestimonial, updateTestimonialSaga),
  ]);
}
export { testimonialSagas };
